import { useState, useEffect, useRef } from 'react';

function clampPage(newPage: number, effectiveMin: number, effectiveMax: number) {
  if (newPage > effectiveMax) return effectiveMax;
  if (newPage < effectiveMin) return effectiveMin;
  return newPage;
}

export const useCarouselIndex = (max: number, min = 0, initial?: number) => {
  const effectiveMin = Math.min(min, max);
  const effectiveMax = Math.max(min, max);

  const [page, setPage] = useState(() => clampPage(initial ?? min, effectiveMin, effectiveMax));

  const setWithBoundaries = (newPage: number) => setPage(clampPage(newPage, effectiveMin, effectiveMax));

  const previousInitialRef = useRef(initial);

  useEffect(() => {
    if (page > effectiveMax) return setPage(effectiveMax);
    if (page < effectiveMin) return setPage(effectiveMin);
  }, [effectiveMin, effectiveMax, page]);

  useEffect(() => {
    if (initial === undefined) return;
    if (previousInitialRef.current === initial) return;

    previousInitialRef.current = initial;
    setPage(clampPage(initial, effectiveMin, effectiveMax));
  }, [initial, effectiveMin, effectiveMax]);

  return {
    page,
    nextPage: () => setWithBoundaries(page + 1),
    previousPage: () => setWithBoundaries(page - 1),
    setPage: setWithBoundaries,
  };
};
